import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfoDialogData } from './info-dialog.interface';

@Component({
  selector: 'app-info-dialog',
  styleUrl: './info-dialog.component.scss',
  templateUrl: './info-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InfoDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: InfoDialogData
  ) {}




}
